import { useTranslation } from '@/i18n';
import { InvoiceReportDetailReportSummaryResponse } from 'ap-openapi';
import classNames from 'classnames/bind';
import styles from './styles.module.scss';

const cx = classNames.bind(styles);

interface TaxAnalyzeProps {
  data?: InvoiceReportDetailReportSummaryResponse['tax_rate_items'];
}

export const TaxAnalyze = ({ data }: TaxAnalyzeProps) => {
  const { t } = useTranslation();
  return (
    <div className={cx('tax-analyze')}>
      {/* Header */}
      <div className={cx('header')}>
        <div className={cx('header-label')}>
          {t('approving_invoice_report_detail_tax_rate_breakdown')}
        </div>
        <div className={cx('header-amount')}>
          {t('approving_invoice_report_detail_subtotal_tax_excluded')}
        </div>
        <div className={cx('header-amount')}>
          {t('approving_invoice_report_detail_consumption_tax_amount')}
        </div>
        <div className={cx('header-amount')}>
          {t('approving_invoice_report_detail_subtotal_tax_included')}
        </div>
      </div>

      {/* Divider */}
      <div className={cx('divider')} />

      {/* Data Rows */}
      {data?.length ? (
        data.map((row) => (
          <div key={row.tax_rate} className={cx('row')}>
            <div className={cx('row-label')}>{row.tax_rate}</div>
            <div className={cx('row-amount')}>{row.subtotal}</div>
            <div className={cx('row-amount')}>{row.excise_values}</div>
            <div className={cx('row-amount')}>{row.subtotal_with_tax}</div>
          </div>
        ))
      ) : (
        <div className={cx('empty')}>
          {t('invoice_report_detail_no_transaction_details')}
        </div>
      )}
    </div>
  );
};
